import React, { Component } from 'react'
import {connect} from 'react-redux'
import ReactDOM from 'react-dom';
import {Button,ButtonToolbar,FormControl,FormGroup,InputGroup,OverlayTrigger,Tooltip} from 'react-bootstrap'
import { AsyncTypeahead } from 'react-bootstrap-typeahead'
import FontAwsome from 'react-fontawesome'
import AutopartStore from 'stores/AutopartStore'
import SWTPartItemListPopup from '../SWTPartItemListModal'
import _ from 'lodash'
import DNDRowItem from './DNDRowItem'
import $ from 'jquery'
import '../WorkDoc.css';

class SWTPartDataGrid extends Component {
  constructor(...props) {
    super(...props)
    
    this.state = {
      data:this.newEmptyRow(props.initNoOfRow,'first'),
      options:[],
      codeOptions:[],
      showPopup:false,
      curData:[],
      can_drag:false,
      darg_id:null
    }

    this.pcInput = new Array(props.initNoOfRow).fill('')
    this.init = false
  }

  componentDidMount() {
    $('body').on('click', ()=> {
      $('.table-responsive').css( "overflow-x", "auto" );
      $('.table-responsive').css( "overflow-y", "" );
    });  
    $('body').on('keydown', ()=> {
      if ($('.tdTypeaHead > div.bootstrap-typeahead').children().length>1) {
        $('.table-responsive').css( "overflow-x", "initial" );
        $('.table-responsive').css( "overflow-y", "unset" );
      } else {
        $('.table-responsive').css( "overflow-x", "auto" );
        $('.table-responsive').css( "overflow-y", "" );
      }
    });
  }

  componentWillReceiveProps(newProps){
    //console.log('1.setPartList',newProps.partList,newProps.show,this.props.show,newProps.name)
    //if(newProps.show  && !this.init){ //&& newProps.show !== this.props.show){    
    if((newProps.show  && !this.init) || (this.init && newProps.show !== this.props.show)){      
      // console.log('2.setPartList',newProps.partList,newProps.show,newProps.name)
      this.setPartList(newProps.partList)
      this.init = true
    }
  }

  getPartList(partFrom=''){
    let {data} = this.state
   // console.log('get',partFrom,data)
    let partList = data.reduce((rresult,item)=>{
      if(item.detail!==''){
        item['partFrom'] = partFrom        
        rresult.push(item)
      }
      return rresult
    },[])
    
    return JSON.parse(JSON.stringify(partList))
  }

  setPartList(partList){
    let data = partList
    // let data = partList.map((item,index)=>{
    //   return {bfId:item.bf_work_damage_id,rowNo:item.seq,itemnum:item.itemnum,productCode:item.productcode,detail:item.detail,quantity:item.quantity,costPerUnit:item.cost_per_unit,pricePerUnit:item.price_per_unit,discountPercent:item.discount_percent,discountAmount:item.discount_amount,amount:item.amount,exportStock:item.export_stock_flag,exportQuantity:item.export_quantity,partFrom:''}
    // })
    if(data.length<=this.props.initNoOfRow){
      data = data.concat(this.newEmptyRow(this.props.initNoOfRow-data.length))
    }
    data = data.map((item,index)=>{
      item.rowNo = (index+1).toString()
      return item
    })

    this.pcInput = new Array(data.length).fill('')
    this.setState({data:data,curData:data})
    // if(this.props.onChange!==undefined)
    //   this.props.onChange(data)
    return data
  }

  addItems(partList){
    let {data} = this.state
    // data = data.reduce(function(rresult,item) {
    //   if(item.detail!=='')
    //     rresult.push(item)
    //   return rresult
    // },[])
    data = []
    let seq = data.length
    let newData = partList.map((item,index)=>{
      seq++
      let amount = item.price_per_unit*item.quantity
      return {bfId:'',rowNo:seq,itemnum:item.itemnum,productCode:item.productcode,detail:item.detail,quantity:item.quantity,costPerUnit:item.cost_per_unit,pricePerUnit:item.price_per_unit,discountPercent:item.discount_percent,discountAmount:item.discount_amount,amount:amount,exportStock:'0'}
    })
    data = data.concat(newData)
    if(data.length<=this.props.initNoOfRow){
      data = data.concat(this.newEmptyRow(this.props.initNoOfRow-data.length))
    }
    this.pcInput = new Array(data.length).fill('')
    this.setState({data:data})
    if(this.props.onChange!==undefined)
      this.props.onChange(data)
  }

  newEmptyRow(number,rowNo=''){
    if (rowNo==='first')
      rowNo = ''
    else {
      let {data} = this.state
      rowNo = (data.length+1).toString()
    }  
    return new Array(number).fill(null).map((item,index)=>{
      return {bfId:'',rowNo:rowNo,itemnum:'',productCode:'',detail:'',quantity:'',pricePerUnit:'',amount:'',costPerUnit:'',exportStock:'0',exportQuantity:0,discountPercent:'',discountAmount:'',partFrom:''}
    })
  }

  onSearch(index,query){
    // let {data} = this.state
    let that = this
    //let options = [{id:1,detail:'test1',amount:2},{id:2,detail:'test2',amount:2}]
    AutopartStore.loadStockPartItemList(-1,query,function(result){
      // console.log(result)
      //options = [{id:1,detail:'test1',amount:2},{id:2,detail:'test2',amount:2}]
      let options = result.data.map((item,index)=>{
        return {id:item.itemnum,productCode:item.productcode,itemnum:item.itemnum,categoryName:item.cat_name,detail:item.description,pricePerUnit:item.price_per_unit,exportQuantity:item.quantity,costPerUnit:item.cost_per_unit,discountPercent:item.discount_percent,discountAmount:item.discount_amount,partFrom:''}
      })
      that.setState({options:options})
    })
   
    //this.setState({options:options})
  }

  onSearchProductCode(index,query){
    // let {data} = this.state
    let that = this
    //let options = [{id:1,detail:'test1',amount:2},{id:2,detail:'test2',amount:2}]
    AutopartStore.loadStockPartProductCode(query,function(result){
      // console.log(result)
      //options = [{id:1,detail:'test1',amount:2},{id:2,detail:'test2',amount:2}]
      let options = result.data.map((item,index)=>{
        return {
          id:item.itemnum,
          productCode:item.productcode,
          itemnum:item.itemnum,
          categoryName:item.cat_name,
          detail:item.description,
          pricePerUnit:item.price_per_unit,
          exportQuantity:item.quantity,
          costPerUnit:item.cost_per_unit,
          discountPercent:item.discount_percent,
          discountAmount:item.discount_amount,
          partFrom:''
        }
      })
      that.setState({codeOptions:options})
    })
   
    //this.setState({options:options})
  }

  // onCodeSearch(index,query){
  //   let that = this
  //   //let options = [{id:1,detail:'test1',amount:2},{id:2,detail:'test2',amount:2}]
  //   AutopartStore.loadStockPartProductCodeList(-1,query,function(result){
  //     // console.log(result)
  //     //options = [{id:1,detail:'test1',amount:2},{id:2,detail:'test2',amount:2}]
  //     let options = result.data.map((item,index)=>{
  //       return {id:item.itemnum,productCode:item.productcode,itemnum:item.itemnum,categoryName:item.cat_name,detail:item.description,pricePerUnit:item.price_per_unit,costPerUnit:item.cost_per_unit,discountPercent:item.discount_percent,discountAmount:item.discount_amount,partFrom:''}
  //     })
  //     // console.log('options',options)
  //     that.setState({codeOptions:options})
  //   })
  // }

  calculateAmount(data,index){
    data[index].amount = data[index].quantity * data[index].pricePerUnit*1
  }

  onSearchKeyPress(index,field,target) {
    // if(target.key==='Enter'){
    if(target.charCode===13){  
      let {data} = this.state
      // console.log("code enter",data[index])    
      let that = this
      //let options = [{id:1,detail:'test1',amount:2},{id:2,detail:'test2',amount:2}]
      this.setState({loading:false})
      let productCode = data[index][field];
      AutopartStore.loadStockPartProductCode(productCode,function(result){
        // console.log(result)
        //options = [{id:1,detail:'test1',amount:2},{id:2,detail:'test2',amount:2}]
        if(result.data.length>0){
          let item = result.data[0]        
          data[index].detail = item.description        
          data[index].productCode = item.productcode
          data[index].itemnum = item.itemnum
          data[index].pricePerUnit = item.price_per_unit
          data[index].costPerUnit = item.cost_per_unit
          data[index].quantity = 1
          data[index].amount  = item.price_per_unit
          data[index].discountPercent  = item.discount_percent
          data[index].discountAmount  = item.discount_amount
          data[index].exportStock = '0'
          data[index].exportQuantity = item.quantity
          if(index===data.length-1){
            //End index
            data = data.concat(that.newEmptyRow(1))
            that.pcInput[index+1] = ''
          }
          that.setState({loading:false,data:data})
          if(that.props.onChange!==undefined)
            that.props.onChange(data)
              
          ReactDOM.findDOMNode(that.pcInput[index+1]).focus();
        }else{
          that.setState({loading:false})
        }
      })      
    }
  }

  onTypeaheadProductCodeChange(index,option){
    let {data} = this.state
    if(option.length===1){
      data[index].productCode = option[0].productCode
      if(option[0].customOption!==true){
        data[index].detail = option[0].detail
        data[index].itemnum = option[0].itemnum
        data[index].pricePerUnit = option[0].pricePerUnit
        data[index].costPerUnit = option[0].costPerUnit
        data[index].discountPercent = option[0].discountPercent
        data[index].discountAmount = option[0].discountAmount
        data[index].quantity = 1
        data[index].amount  = option[0].pricePerUnit
        data[index].exportStock = '0'
        data[index].exportQuantity = option[0].exportQuantity
      }
    }
    this.setState({data:data})
    if(this.props.onChange!==undefined)
      this.props.onChange(data)

  }

  onTypeaheadChange(index,option){
    let {data} = this.state
    if(option.length===1){
      data[index].detail = option[0].detail
      if(typeof option[0].productCode !=='undefined'){
        data[index].productCode = option[0].productCode
        data[index].itemnum = option[0].itemnum
        data[index].pricePerUnit = option[0].pricePerUnit
        data[index].costPerUnit = option[0].costPerUnit
        data[index].discountPercent = option[0].discountPercent
        data[index].discountAmount = option[0].discountAmount
        data[index].quantity = 1
        data[index].amount  = option[0].pricePerUnit
        data[index].exportStock = '0'
        data[index].exportQuantity = option[0].exportQuantity
      }
    }
    // else{
    //   data[index].detail = ''
    // }
    this.setState({data:data})
    if(this.props.onChange!==undefined)
      this.props.onChange(data)

  }

  onTypeaheadInputChange(index,query){
    //console.log('typeChagne',e,text)
    //console.log("query",query)
    let {data} = this.state
    data[index]['detail'] = query
    
    
    this.setState({data:data})
  }

  onTypeaheadProductCodeInputChange(index,query,e){
    //console.log('typeChagne',e,text)
    //console.log("query",query)
    let {data} = this.state
    data[index]['productCode'] = query
    
    
    this.setState({data:data})
  }

  onTypeaheadCodeChange(index,option){
    // console.log('options',index,option)

    let {data} = this.state
    if(option.length===1){
      data[index].productCode = option[0].productCode
      if(typeof option[0].detail !=='undefined'){
        data[index].detail = option[0].detail
        data[index].itemnum = option[0].itemnum
        data[index].pricePerUnit = option[0].pricePerUnit
        data[index].costPerUnit = option[0].costPerUnit
        data[index].discountPercent = option[0].discountPercent
        data[index].discountAmount = option[0].discountAmount
        data[index].quantity = 1
        data[index].amount  = option[0].pricePerUnit
        data[index].exportStock = '0'
        data[index].exportQuantity = option[0].exportQuantity        
      }
    }
    // else{
    //   data[index].detail = ''
    // }
    this.setState({data:data})
    if(this.props.onChange!==undefined)
      this.props.onChange(data)
  
  }

  sortRowIndex(itemlist) {
    itemlist = itemlist.map((item,index)=>{
      item.rowNo = (index+1).toString()
      return item
    })
    return itemlist
  }

  onRemoveRowClick(index){
    let {data} = this.state
    data.splice(index,1);
    data = this.sortRowIndex(data)
    this.setState({data:data})
    if(this.props.onChange!==undefined)
      this.props.onChange(data)
  
  }

  onAddEmptyRowItemClick(number){
    let {data} = this.state

    let newRows = this.newEmptyRow(number)

    data = data.concat(newRows)
    this.pcInput = new Array(data.length).fill('')
    this.setState({data:data})
  
  }

  onSearchClick(){
    //this.refs.partItemPopup.getWrappedInstance().openPopup();
    this.setState({showPopup:true})
  }

  convertPartItem(newItem){
    let item = this.newEmptyRow(1)[0]
    item.itemnum = newItem.itemnum
    item.productCode = newItem.productcode
    item.detail = newItem.description
    item.quantity = 1
    item.pricePerUnit = newItem.price_per_unit     
    item.costPerUnit = newItem.cost_per_unit
    item.amount = newItem.price_per_unit
    item.exportStock = '0'
    item.exportQuantity = newItem.quantity
    return item
  }

  onItemSelect(newItem){
    //Finding Last row
    let {data} = this.state
    let foundItem = false
    newItem = this.convertPartItem(newItem)
    data = data.map((item,index)=>{
      if(item.detail==='' && !foundItem){
        item = newItem
        foundItem = true
      }
      return item
    })

    if(!foundItem){
      data.push(newItem)
    }

    this.setState({data:data})
    if(this.props.onChange!==undefined)
      this.props.onChange(data)
  
  }

  summaryCostAmount(){
    let {data} = this.state
    let sum = 0;
     data.forEach((item,index)=>{
       if(item.detail!=='')
          sum += item.costPerUnit*item.quantity*1
    })
    sum = parseFloat(sum).toLocaleString(undefined, {minimumFractionDigits: 2})
    return (<span>{sum}</span>)


  }

  summaryAmount(){
    let {data} = this.state
    let sum = 0;
     data.forEach((item,index)=>{
       if(item.detail!=='')
          sum += item.amount*1
    })
    sum = parseFloat(sum).toLocaleString(undefined, {minimumFractionDigits: 2})
    return (<span>{sum}</span>)
  }

  

  _renderMenuItemChildren(option, props, index) {
    if(option.pricePerUnit>0){
      return (
        <div key={option.id}>               
          <span>{option.detail} (หมวด{option.categoryName}) - {option.pricePerUnit} บาท</span>
        </div>
      );
    }else{
      return (
        <div key={option.id}>               
          <span>{option.detail}</span>
        </div>
      );
    }
  }

  _renderProductCodeMenuItemChildren(option, props, index) {
    if(option.pricePerUnit>0){
      return (
        <div key={option.id}>               
          <span>{option.productCode} (หมวด{option.categoryName}) - {option.pricePerUnit} บาท</span>
        </div>
      );
    }else{
      return (
        <div key={option.id}>               
          <span>{option.productCode}</span>
        </div>
      );
    }
  }

  _renderMenuItemProductCodeChildren(option, props, index) {
    if(option.pricePerUnit>0){
      return (
        <div key={option.id}>               
          <span>{option.productCode} {option.detail} (หมวด{option.categoryName}) - {option.pricePerUnit} บาท</span>
        </div>
      );
    }else{
      return (
        <div key={option.id}>               
          <span>{option.productCode} {option.detail}</span>
        </div>
      );
    }
  }

  renderCheckStock(item){
    let {exportStock,exportQuantity} = item
    if(exportStock==='1'){
      return (<FontAwsome name='check' className='text-large'/>)
    }else if(exportStock==='2'){
      return (<FontAwsome name='lock' className='text-large text-red'/>)  
    }else if(item.detail!=='' && (item.itemnum*1===0 || item.itemnum==='')){
      return (<FontAwsome name='question' className='text-large'/>)            
    }else if(item.detail!=='' && exportQuantity>=0){
      return (<div>{exportQuantity}</div>)
    }else{
      return (<div/>)
    }
  }

  renderColumnDiscountAmount(){
    let {hidePriceOnDamage} = this.props
    if(hidePriceOnDamage){
      return ('')
    }
    let {messages} = this.props
    if(this.props.showDiscount){
      return (
        <th style={{width:'80px'}} className='text-center'>{messages['Discount']}</th> 
      )
    }else{
      return (
        ''
      )
    }
  }

  renderColumnDiscountPercent(){
    let {hidePriceOnDamage} = this.props
    if(hidePriceOnDamage){
      return ('')
    }
    let {messages} = this.props
    if(this.props.showDiscount){
      return (
        <th style={{width:'80px'}} className='text-center'>{messages['Discount %']}</th> 
      )
    }else{
      return (
        ''
      )
    }
  }

  renderDiscountPercent(item,index){
    let {hidePriceOnDamage} = this.props
    if(hidePriceOnDamage){
      return ('')
    }
    if(this.props.showDiscount){
      return (
        <td key={6} className='text-right'>
          <FormGroup>
            <InputGroup>
              <FormControl 
                style={{borderTopRightRadius:'4px',borderBottomRightRadius:'4px'}}
                type="text" 
                className='text-center'
                value={item.discountPercent}
                onChange={this.onTextChange.bind(this,index,'discountPercent')}
              />
              <InputGroup.Addon style={{padding:'0',border:'none',backgroundColor:'inherit'}}>%</InputGroup.Addon>
            </InputGroup>
          </FormGroup>           
        </td>
    )
    }else{
      return ('')
    }
  }

  renderDiscountAmount(item,index){ 
    let {hidePriceOnDamage} = this.props
    if(hidePriceOnDamage){
      return ('')
    }
    if(this.props.showDiscount){
      return (
        <td key={7} className='text-right'>
          <FormControl 
            className='text-right' 
            value={item.discountAmount}
            onChange={this.onTextChange.bind(this,index,'discountAmount')}
          />      
        </td>
    )
    }else{
      return ('')
    }
  }

  // getAmount(item,index) {
  //   let {data} = this.state
  //   let discount = 0
  //   let amount = 0
  //   let price = 0
  //   price = item.pricePerUnit * item.quantity
  //   if (item.discountAmount<=0||isNaN(item.discountAmount)===true||item.discountAmount==="") {
  //     discount = 0
  //   } else {
  //     discount = item.discountAmount
  //   }  
  //   amount = price - discount
  //   if (amount===0||isNaN(amount)===true||amount===""){
  //     item.amount = 0
  //   } else {
  //     item.amount = amount
  //   }  
  // }

  getDiscountAmount(index) {
    let {data} = this.state
    if (data[index]['discountPercent']<=0||isNaN(data[index]['discountPercent'])===true){
      data[index]['discountAmount'] = 0
    } else {
      let discount = 0
      let price = 0
      price = data[index]['pricePerUnit'] * data[index]['quantity']
      discount = (price / 100) * data[index]['discountPercent']
      if (discount%1 !== 0) {
        discount = discount.toFixed(2)
        // discount = Math.round(discount)
      }
      data[index]['discountAmount'] = discount
    }
    this.setState({data:data})
    if(this.props.onChange!==undefined)
      this.props.onChange(data)
  }

  getDiscountPercent(index) {
    let {data} = this.state
    if (data[index]['discountAmount']<=0||isNaN(data[index]['discountAmount'])===true){
      data[index]['discountPercent'] = 0
    } else {  
      let price = 0
      let discount = 0
      price = data[index]['pricePerUnit'] * data[index]['quantity']
      discount = (data[index]['discountAmount'] / price) * 100
      if (discount%1 !== 0) {
        discount = discount.toFixed(2)
        // discount = Math.round(discount)
      }
      data[index]['discountPercent'] = discount
    }  
    this.setState({data:data})
    if(this.props.onChange!==undefined)
      this.props.onChange(data)
  
  }

  onTextChange(index,field,e){
    let {data} = this.state
    // console.log('row',index,field,e.target.value)
    // let amount = e.target.value
    // if(isNaN(amount)){
    //   data[index][field] = ''
    // }else{
    //   data[index][field] = amount*1
    // }
    // this.calculateAmount(data,index)
    data[index][field] = e.target.value
    if(field==='pricePerUnit' || field==='quantity'){
      //this.calculateAmount(data,index)
      data[index].amount = (data[index].quantity*1) * (data[index].pricePerUnit*1)
    }else if(field==='productCode'){

    }else if(field==='costPerUnit') {
      
    }
    
    this.setState({data:data})
    if(this.props.onChange!==undefined)
      this.props.onChange(data)
  
    // console.log(data[index])
    if (field==='discountAmount') {
      this.getDiscountPercent(index)
    } else if (field==='discountPercent') {
      this.getDiscountAmount(index)
    } else if (field==='quantity'||field==='pricePerUnit') {
      if ((e.target.value<=0||isNaN(e.target.value)===true||e.target.value==="")||(data[index].quantity<=0||isNaN(data[index].quantity)===true||data[index].quantity==="")||(data[index].pricePerUnit<=0||isNaN(data[index].pricePerUnit)===true||data[index].pricePerUnit==="")){
        this.getMistakeAmount(index)
      } else {  
        //this.getDiscountPercent(index)
        this.getDiscountAmount(index)
      }    
    }

    let discount = 0
    let amount = 0
    let price = 0
    price = data[index].pricePerUnit * data[index].quantity
    if (data[index].discountAmount<=0||isNaN(data[index].discountAmount)===true||data[index].discountAmount==="") {
      discount = 0
    } else {
      discount = data[index].discountAmount
    }  
    amount = price - discount
    if (amount===0||isNaN(amount)===true||amount===""){
      data[index].amount = 0
    } else {
      data[index].amount = amount
    }
  }

  getMistakeAmount(index) {
    let {data} = this.state
    data[index]['discountAmount'] = 0
    data[index]['amount'] = 0
    this.setState({data:data})
    if(this.props.onChange!==undefined)
      this.props.onChange(data)
  
  }  

  renderColumnCostPerUnit(){
    let {messages,hidePriceOnDamage} = this.props
    
    if(hidePriceOnDamage){
      return ('')
    }
    if(this.props.showCostPerUnit){
      return (
        <th style={{width:'120px'}} className='text-center'>{messages['Cost/Unit']}</th> 
      )
    }else{
      return (
        ''
      )
    }
  }

  rednerColumnPricePerUnit(){
    let {hidePriceOnDamage,messages} = this.props
    if(hidePriceOnDamage){
      return ('')
    }
    return (<th style={{width:'110px'}} className='text-center'>{messages['Price/Unit']}</th>)
  }

  renderColumnAmount(){
    let {hidePriceOnDamage,messages} = this.props
    if(hidePriceOnDamage){
      return ('')
    }
    return (<th style={{width:'110px'}} className='text-center'>{messages['Amount']}</th> )
  }

  renderPricePerUnit(item,index){
    let {hidePriceOnDamage} = this.props
    if(hidePriceOnDamage){
      return ('')
    }
    return (
      <td key={5} className='text-right'>
                  <FormControl className='text-right' 
                  value={item.pricePerUnit} 
                  onChange={this.onTextChange.bind(this,index,'pricePerUnit')}/>                  
                </td>
    )
  }

  renderAmount(item,index){
    let {hidePriceOnDamage} = this.props
    if(hidePriceOnDamage){
      return ('')
    }

    return (<td key={8} className='text-right'>
              <FormControl className='text-right'
                value={item.amount}
              />                  
            </td>)

  }

  renderCostPerUnit(item,index){
    if(this.props.showCostPerUnit){
      let validationState = null

      if(this.props.partCostRequire){
        if(item.detail!==''&&item.costPerUnit*1===0){
          validationState = 'error'
        }
      }
      return (
        <td key={4} className='text-right'>
          <FormGroup controlId="formValidationErrorCost" validationState={validationState}>
            <FormControl className='text-right' 
            value={item.costPerUnit}
            readOnly={!this.props.partCostRequire}
            onChange={this.onTextChange.bind(this,index,'costPerUnit')}/>     
          </FormGroup>            
        </td>
    )
    }else{
      return ('')
    }
  }

  renderColDetail(index,item) {
    let {messages} = this.props
    let {options,codeOptions,can_drag,darg_id} = this.state
    let uniq = item.rowNo
    let {exportStock} = item
    let hover = (
      <OverlayTrigger
          key={'right'}
          placement={'right'}
          overlay={
              <Tooltip id={'tooltip-right'}>
                Hold & darg to sort the Items
              </Tooltip>
          }
          >
          <div className='wrap-tool'>
            <div className='card-tool'><FontAwsome name='bars' /></div>
          </div>
      </OverlayTrigger>
    )
    let readOnly = (exportStock*1==1)
    return([
                <td 
                  key={0} 
                  className='text-center'
                  style={{verticalAlign:'middle',width:'50px',minWidth:'50px'}}
                  onMouseEnter={()=>{this.setState({can_drag:true,darg_id:uniq})}} 
                  onMouseLeave={()=>{this.setState({can_drag:false,darg_id:null})}}
                >
                  {can_drag&&darg_id===uniq?hover:index+1}
                </td>,
                <td key={1} className='text-left' className='tdTypeaHead'>
                  <FormControl className='text-left' 
                  ref={(input) => { this.pcInput[index] = input; }}                   
                  value={item.productCode} 
                  onChange={this.onTextChange.bind(this,index,'productCode')}
                  onKeyPress={this.onSearchKeyPress.bind(this,index,'productCode')}
                  />                           
                </td>,                
                <td key={2} className='tdTypeaHead'>
                  <AsyncTypeahead
                    id={'key-1-'+index}                    
                    allowNew={true}
                    multiple={false}
                    newSelectionPrefix={messages['Add New Item']+' : '}   
                    promptText={messages['Keypress For Searching']}           
                    searchText={messages['Searching']}                    
                    selected={[{detail:item.detail}]}
                    options={options}
                    labelKey="detail"
                    onSearch={this.onSearch.bind(this,index)}
                    onChange={this.onTypeaheadChange.bind(this,index)}
                    onInputChange={this.onTypeaheadInputChange.bind(this,index)}
                    placeholder=""
                    renderMenuItemChildren={this._renderMenuItemChildren.bind(this)}
                  />                  
                </td>,
                <td key={3} className='text-right'>
                  <FormControl className='text-center'                   
                  value={item.quantity} 
                  onChange={this.onTextChange.bind(this,index,'quantity')}/>                  
                </td>,
                this.renderCostPerUnit(item,index),
                this.renderPricePerUnit(item,index),                    
                this.renderDiscountPercent(item,index),
                this.renderDiscountAmount(item,index),
                this.renderAmount(item,index),             
                <td key={9} className='text-center'>
                  {this.renderCheckStock(item)}                              
                </td>,
                <td key={10}>
                  <Button bsStyle={'danger'} bsSize={'sm'} onClick={this.onRemoveRowClick.bind(this,index)}><FontAwsome name="trash"/></Button>
                </td>
    ])
  }

  renderRowData(){
    let {data,can_drag} = this.state
    return data.map((item,index)=> { 
      return <DNDRowItem 
        key={index} 
        id={item.rowNo}
        item={item}
        can_drag={can_drag}
        moveRow={this.onMoveRow.bind(this)}
        renderColDetail={this.renderColDetail.bind(this,index)}
      />
    })
  }

  onMoveRow(id,afterId) {
    let {data} = this.state
    var rows = _.clone(data);
    var currentRow = _.filter(rows, function (r) { return r.rowNo === id; })[0];
    var afterRow = _.filter(rows, function (r) { return r.rowNo === afterId; })[0];

    var currentRowIndex = rows.indexOf(currentRow);
    var afterRowIndex = rows.indexOf(afterRow);

    // remove the current row
    rows.splice(currentRowIndex, 1);
    // put it after
    rows.splice(afterRowIndex, 0, currentRow);

    data = rows
    this.setState({data: data});
  }

  renderFooter(){
    let {messages,hidePriceOnDamage,showCostPerUnit} = this.props
    if(hidePriceOnDamage){
      return ('')
    }
    let colSpan = 0,colSpan2=0
    if (this.props.showCostPerUnit&&this.props.showDiscount) {
      colSpan = 4
      colSpan2=3
    } else if (!this.props.showCostPerUnit&&!this.props.showDiscount) {
      colSpan = 5
    } else if (!this.props.showCostPerUnit&&this.props.showDiscount) {
      colSpan = 7
    } else if (this.props.showCostPerUnit&&!this.props.showDiscount) {
      colSpan = 4
    }
    if(showCostPerUnit){
      return (<tfoot>
        <tr>
          <th colSpan={colSpan} className='text-right'>{'รวมต้นทุน'}</th> 
          <th colSpan={1} className='text-right'>{this.summaryCostAmount()}</th> 
          <th colSpan={colSpan2} className='text-right'>{'รวม'}</th>            
          <th className='text-right'>{this.summaryAmount()}</th>
          <th colSpan={2}></th>
        </tr>
      </tfoot>)      
    }else{
      return (<tfoot>
        <tr>
          <th colSpan={colSpan} className='text-right'>{messages['Total Parts']}</th>            
          <th className='text-right'>{this.summaryAmount()}</th>
          <th colSpan={2}></th>
        </tr>
      </tfoot>)
      }
  }

  renderTable(){
    // let colSpan = (this.props.showCostPerUnit)?6:5
    let {messages} = this.props
    
    return (
      <div className='table-responsive'>
        <table className='table table-hover table-bordered-solid' style={{minWidth:'1280px'}}>
          <thead>
            <tr>
              <th style={{width:'50px'}}  className='text-center'>{messages['Number']}</th>
              <th style={{width:'180px'}}  className='text-left'>{messages['Part No.']}</th>
              <th className='text-center'>{messages['Item']}</th>
              <th style={{width:'70px'}} className='text-center'>{messages['Quantity']}</th>    
              {this.renderColumnCostPerUnit()}
              {this.rednerColumnPricePerUnit()}
              {this.renderColumnDiscountPercent()}
              {this.renderColumnDiscountAmount()}
              {this.renderColumnAmount()}            
              <th style={{width:'50px'}} className='text-center'>{messages['Stock']}</th>          
              <th style={{width:'50px'}} className='text-center'>{messages['Delete']}</th>            
            </tr>          
          </thead>
          <tbody>
            {this.renderRowData()}
          </tbody>
          {this.renderFooter()}
        </table>
      </div>  
    )
  }

  

  render() {
    let {showPopup} = this.state
    let {messages} = this.props
    return (
      <div>
        {this.renderTable()}
        <ButtonToolbar>
          <Button bsStyle={null} className='bg-olive'           
            onClick={this.onAddEmptyRowItemClick.bind(this,1)}
          >
            + {messages['Add Item']}
          </Button>
          <Button bsStyle={null} className='bg-olive' 
            onClick={this.onAddEmptyRowItemClick.bind(this,10)}
          >
            + {messages['Add 10 Item']}
          </Button>
          <Button bsStyle={'primary'}             
            onClick={this.onSearchClick.bind(this)}
          >
          <FontAwsome name='search'/>&nbsp;{messages['Search Parts']}
          </Button>
        </ButtonToolbar>
        <SWTPartItemListPopup ref='partItemPopup' show={showPopup} onSelect={this.onItemSelect.bind(this)} onHide={()=>{this.setState({showPopup:false})}}/>
      </div>
    )
  }
}

SWTPartDataGrid.defaultProps = {
  show : false,
  name:'',
  partList : [],
  initNoOfRow:10,
  partCostRequire:false,
  hidePriceOnDamage:false,
  showCostPerUnit:false
}

export default SWTPartDataGrid = connect(
  (state) => ({messages: state.message.view.workdoc.SWTPartDataGrid}),null,null,{withRef:true}
)(SWTPartDataGrid);



// WEBPACK FOOTER //
// ./src/view/workdoc/fast/SWTPartDataGrid.js